var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#54AB8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4437 19.8885C33.9123 19.4199 33.9123 18.6601 33.4437 18.1914C32.975 17.7228 32.2152 17.7228 31.7466 18.1914L20.7158 29.2222L16.4733 24.9797C16.0047 24.5111 15.2449 24.5111 14.7763 24.9797C14.3076 25.4483 14.3076 26.2081 14.7763 26.6768L19.8543 31.7548C19.8586 31.7592 19.8629 31.7636 19.8672 31.7679C20.0476 31.9482 20.271 32.0592 20.5044 32.1007C20.8776 32.1672 21.2762 32.0563 21.5645 31.7679C21.5697 31.7627 21.5749 31.7575 21.5799 31.7522L33.4437 19.8885Z",
    fill: "#FAF9F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f873d47399e76806ab6c376dbea392fc.svg";
export { ForwardRef as ReactComponent };